import { render } from "./InscriptionForm.vue?vue&type=template&id=3c40fbea"
import script from "./InscriptionForm.vue?vue&type=script&lang=js"
export * from "./InscriptionForm.vue?vue&type=script&lang=js"

import "./InscriptionForm.vue?vue&type=style&index=0&id=3c40fbea&lang=scss"

import exportComponent from "/Users/anthony/Documents/APP/SIMEF LAST/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__